import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

/** Sits above `#root-loader` (z-index 9999); below session snackbars (10050). */
const HINT_Z = 10040

/**
 * Optional guidance when session/role verification is slow (shown under boot loaders, not in the toast).
 */
export default function SlowConnectionTroubleshootHint() {
  return (
    <Box
      component="aside"
      aria-label="Troubleshooting tips for slow connection"
      sx={{
        position: 'fixed',
        bottom: 24,
        left: 16,
        right: 16,
        zIndex: HINT_Z,
        textAlign: 'center',
        pointerEvents: 'auto',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          bgcolor: 'rgba(255,255,255,0.94)',
          p: 1.75,
          borderRadius: 1,
          boxShadow: 2,
          maxWidth: 520,
          mx: 'auto',
          lineHeight: 1.5,
        }}
      >
        If you think something is wrong, try a quick speed test at{' '}
        <Link href="https://www.fast.com" target="_blank" rel="noopener noreferrer">
          fast.com
        </Link>
        . If your connection looks fine, take a screenshot and include it when you contact support so we can
        help faster.
      </Typography>
    </Box>
  )
}
